<span [class]="className" (click)="select()"></span>
